import { MKError } from "../../interfaces";
import { MKConstants, MKCustomError } from "../../constants";

/**
 * MKPlayer error base class.
 * @internal
 */
export class MKPlayerError implements MKError {
    code: string;
    name: string;
    message: string;

    constructor() {
        this.name = "MKPlayerError";
        // initialize with unknown error code & message
        this.message = MKCustomError.Unknown.message;
        this.code = MKConstants.ErrorCodeTemplate.PlayerError.replace("{submodule}", "0").replace("{code}", MKCustomError.Unknown.code);
    }
}